import { useAuth } from '../auth/hooks/use-auth';

export const useIsKognitosEmployee = () => {
  const { user } = useAuth();
  return Boolean(user?.email?.toLowerCase().endsWith('@kognitos.com'));
};
